/* faq-accordion.js
   Custom element that powers <faq-accordion> blocks in the FAQ section.
   The actual height + icon animations are CSS (grid-template-rows trick
   for the content, opacity transition on the vertical icon line). This
   JS toggles aria-expanded on the trigger when clicked, and keeps only
   one FAQ open at a time within the same section.
*/
(function () {
  if (customElements.get('faq-accordion')) return;

  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      this._trigger = this.querySelector('.faq-section__trigger');
      if (!this._trigger) return;

      this._onClick = () => {
        const isOpen = this._trigger.getAttribute('aria-expanded') === 'true';
        const willOpen = !isOpen;

        this._trigger.setAttribute('aria-expanded', String(willOpen));

        // Khulte waqt isi section ke baqi FAQs band kar do
        if (willOpen) this._closeSiblings();
      };

      this._trigger.addEventListener('click', this._onClick);
    }

    _closeSiblings() {
      const scope = this.closest('.faq-section') || document;
      scope.querySelectorAll('faq-accordion').forEach((acc) => {
        if (acc === this) return;
        const trigger = acc.querySelector('.faq-section__trigger');
        if (trigger && trigger.getAttribute('aria-expanded') === 'true') {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    disconnectedCallback() {
      if (this._trigger && this._onClick) {
        this._trigger.removeEventListener('click', this._onClick);
      }
    }
  }

  customElements.define('faq-accordion', FaqAccordion);
})();